import { createStore } from 'killa';

const initialState = {
  installationProcess: [{
    type: window.Resources?.SnapeHelperScriptsJS?.WaitingStatusFromTheServer,
    progress: 0,
    subText: "",
    isError: false
  }]
};

const store = createStore(initialState);

window.installationStore = store;

const reset = () => {
  window.installationStore.setState(() => {
    return {
      installationProcess: [{
        type: window.Resources?.SnapeHelperScriptsJS?.WaitingStatusFromTheServer,
        progress: 0,
        subText: "",
        isError: false
      }]
    };
  });
};

const filterOutWiatingStatusFromTheServer = (list) => {
  return list.filter(({ type }) => type !== window.Resources?.SnapeHelperScriptsJS?.WaitingStatusFromTheServer)
}

const handleEvent = (type, e) => {
  const uploadingFileExist = window.installationStore.getState().installationProcess.find((item) => item.type === type);

  if (!uploadingFileExist) {
    window.installationStore.setState((state) => {
      return {
        installationProcess: filterOutWiatingStatusFromTheServer([...state.installationProcess, e.detail])
      };
    });
  } else {
    window.installationStore.setState((state) => {
      return {
        installationProcess: filterOutWiatingStatusFromTheServer(state.installationProcess.map((item) => {
          if (item.type === type) {
            return {
              ...item,
              ...e.detail
            };
          }
          return item;
        }))
      };
    });
  }
};

const handleDownloadingPackage = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.DownloadingPackage, e);
const handleProcessingRollback = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.ProcessingRollback, e);
const handleInstallSnapeFile = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.InstallSnapePackage, e);
const handleInstallationFinished = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.InstallationFinished, e);
const handleInstallMeshFile = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.InstallMeshUpdate, e);
const handleInstallingFile = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.InstallingPackage, e);
const handleUploadingFile = (e) => handleEvent(window.Resources?.SnapeHelperScriptsJS?.UploadingPackage, e);

export const installationProcessModel = {
  store,
  reset,
  handleDownloadingPackage,
  handleProcessingRollback,
  handleInstallSnapeFile,
  handleInstallationFinished,
  handleInstallMeshFile,
  handleInstallingFile,
  handleUploadingFile
};
